import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/ecommdev/frontend/components/commercetools-ui/organisms/home-brand-refresh/brand-pdp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/ecommdev/frontend/components/commercetools-ui/organisms/home-brand-refresh/brand-refresh-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/ecommdev/frontend/components/commercetools-ui/organisms/home-brand-refresh/menu.tsx");
